import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../store/slice/auth/slice';
import vendorSlice from './slice/vendor/slice';
import onboardingSlice from './slice/onboarding/slice';
import toDoSlice from './slice/toDo/slice';
import appointmentSlice from './slice/appointment/slice';
import weddingSlice from './slice/wedding/slice';
import chatSlice from './slice/chat/slice';
import notificationSlice from './slice/notification/slice';
import paymentsSlice from './slice/payment/slice';
import rsvpSlice from './slice/rsvp/slice';
import commonSlice from './slice/faq/slice';

const store = configureStore({
  reducer: {
    onboardingInfo: onboardingSlice,
    auth: authSlice,
    vendorsInfo: vendorSlice,
    toDosInfo: toDoSlice,
    appointmentInfo: appointmentSlice,
    weddingInfo: weddingSlice,
    chatInfo: chatSlice,
    notificationInfo: notificationSlice,
    paymentInfo: paymentsSlice,
    rsvpInfo: rsvpSlice,
    commonInfo: commonSlice,
  },
  devTools: true,
});

export default store;
